module.exports = __webpack_public_path__ + "img/czsc_15.33d2f295.png";